import HiComponent from "./HiComponent";

export { HiComponent }